import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { useStoreActions } from '~/contexts';
import { useContacts } from '~/hooks/reactQuery/queries/useContacts';
import { QueryKeys } from '~/hooks/reactQuery/queryKeys';
import { useQueryState } from '~/hooks/reactQuery/useQueryState';
export const useArchivedProposals = ()=>{
    const { api } = useStoreActions();
    const { refresh: refreshContacts } = useContacts();
    const { data: archivedProposalsWithContact, isLoading, isBackgroundLoading, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ArchivedProposals
        ],
        queryFn: async ()=>{
            const [{ data: contacts }, drafts] = await Promise.all([
                refreshContacts(),
                api.draft.getArchivedSummaries()
            ]);
            return drafts.map((draft)=>_object_spread_props(_object_spread({}, draft), {
                    contactDetails: contacts === null || contacts === void 0 ? void 0 : contacts.filter((contact)=>contact.id() === draft.clientContactId).map((contact)=>({
                            firstName: contact.firstName(),
                            lastName: contact.lastName(),
                            email: contact.email(),
                            companyName: contact.companyName()
                        }))[0]
                }));
        },
        keepDataFresh: true
    });
    return {
        drafts: archivedProposalsWithContact,
        isBackgroundLoading,
        isLoading,
        error,
        refresh
    };
};
